var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158,
    height: 40,
    viewBox: "0 0 158 40",
    fill: "none",
    title: "DBS US - UAT",
    className: "injected-svg store-logo lazyloaded",
    "data-src": "https://cdn11.bigcommerce.com/s-eb52p33wq0/stencil/959eb590-0289-013e-b96e-561d072de925/e/2f191690-0340-013e-bb86-46f3d3da1878/img/logo.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dbs-logo-dark",
    clipPath: "url(#clip0_2724_21988-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SATZ"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.4147 40H0.702271V36.3225H18.002L19.4147 34.9775V31.569L18.002 30.0435H4.44154L0.702271 26.1413V20.4415L4.44154 16.7672H22.1532V20.4415H6.08592L4.44154 22.103V24.7931L6.08592 26.1413H19.4147L23.1572 30.0435V36.2782L19.4147 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.7924 40H42.0531V20.4415H33.4901V16.7672H54.6514V20.4415H45.7924V40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M85.3539 40H72.4563L68.3953 36.3225V16.7672H72.1378V34.4394L73.7339 36.3225H84.0313L85.6274 34.4394V16.7672H89.3699V36.3225L85.3539 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M123.406 40H119.075L115.287 30.9835H106.219V40H102.48V16.7735H119.667L123.406 20.4447V27.575L119.348 30.5784L123.406 40ZM119.667 25.5558V22.2834L117.797 20.4447H106.213V27.306H117.797L119.667 25.5558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M157.298 40H153.559V23.1347H153.468L146.144 36.9491L138.82 23.1347H138.73V40H134.991V16.7672H138.73L146.144 30.4929L153.559 16.7672H157.298V40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M23.3277 1.26592H27.4918L28.0903 1.95902V6.09858L27.4918 6.73155H23.3277V1.26592ZM22.0405 0V7.99747H28.0292L29.3775 6.73155V1.26592L28.0292 0H22.0405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34.9542 1.26592H39.1826L39.8262 1.89888V3.02872L39.1826 3.63003H34.9542V1.26592ZM33.667 0V7.99747H34.9542V4.89596H38.3169L39.6041 7.99747H41.0973L39.7135 4.74721L41.1133 3.71232V1.26592L39.8262 0H33.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M47.0408 7.95315C46.9486 8.04529 46.8387 8.11848 46.7174 8.16843C46.5961 8.21838 46.466 8.24411 46.3345 8.24411C46.203 8.24411 46.0729 8.21838 45.9516 8.16843C45.8303 8.11848 45.7204 8.04529 45.6282 7.95315C45.5327 7.86523 45.4569 7.75881 45.4054 7.64061C45.3538 7.5224 45.3278 7.39498 45.3289 7.26638C45.3288 7.00343 45.434 6.75102 45.6217 6.5638C45.7117 6.46486 45.8218 6.38559 45.9448 6.33107C46.0679 6.27656 46.2012 6.24803 46.3361 6.24731C46.4694 6.24521 46.6017 6.27027 46.7246 6.32093C46.8476 6.37158 46.9585 6.44673 47.0505 6.54164C47.1441 6.6318 47.218 6.73975 47.2678 6.8589C47.3176 6.97805 47.3422 7.10593 47.3401 7.23474C47.3414 7.36476 47.3155 7.49365 47.264 7.61342C47.2125 7.73319 47.1365 7.84128 47.0408 7.93099",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M60.2088 4.46238H64.2634L64.8459 5.03521V6.03845L64.2634 6.73471H60.2088V4.46238ZM60.2088 1.26592H64.3729L64.8459 1.89888V2.6711L64.2634 3.19646H60.2088V1.26592ZM58.9216 0V7.99747H64.8137L66.1331 6.73155V4.51618L65.4251 3.79777L66.1331 3.13316V1.26592L64.8137 0H58.9216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M73.6309 1.48429L75.3589 4.84848H71.964L73.6309 1.48429ZM73.0195 0L69.0356 7.99747H70.3711L71.2689 6.11441H75.9382L76.9679 7.99747H78.3034L74.2713 0H73.0195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M82.7602 1.26592H86.9854L87.629 1.89888V3.02872L86.9854 3.63003H82.7602V1.26592ZM81.473 0V7.99747H82.7602V4.89596H86.123L87.4262 7.99747H88.9194L87.5164 4.74721L88.9129 3.71232V1.26592L87.6258 0H81.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M94.6892 4.46238H98.8242L99.4035 5.03521V6.03845L98.8242 6.73471H94.6892V4.46238ZM94.6892 1.26592H98.9337L99.4035 1.89888V2.6711L98.8242 3.19646H94.6892V1.26592ZM93.402 0V7.99747H99.3777L100.694 6.73155V4.51618L99.9859 3.79777L100.691 3.13316V1.26592L99.3745 0H93.402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M108.234 1.48429L109.939 4.84848H106.596L108.234 1.48429ZM107.632 0L103.712 7.99747H105.025L105.907 6.11441H110.499L111.519 7.99747H112.839L108.861 0H107.632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M117.392 1.26592H121.617L122.261 1.89888V3.02872L121.617 3.63003H117.392V1.26592ZM116.105 0V7.99747H117.392V4.89596H120.758L122.045 7.99747H123.538L122.155 4.74721L123.551 3.71232V1.26592L122.264 0H116.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M131.075 1.48429L132.796 4.84848H129.421L131.075 1.48429ZM130.47 0L126.524 7.99747H127.853L128.742 6.11441H133.372L134.402 7.99747H135.731L131.712 0H130.47Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2724_21988-6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156.596,
    height: 40,
    fill: "white",
    transform: "translate(0.702271)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.de319f0e70925f2e8f9f5d1eaebfca98.svg";
export { ForwardRef as ReactComponent };